import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  getCurrentPropertySuccess,
  getCurrentPropertyFail,
  getPropertiesSuccess,
  getPropertiesFail,
  getMlPropertiesSuccess,
  getMlPropertiesFail,
  getMlEnginePropertiesSuccess,
  getMlEnginePropertiesFail,
  getCirclesSuccess,
  getCirclesFail,
  getNotificationCountSuccess,
  getNotificationCountFail,
  setPropertyApprovalSuccess,
  setPropertyApprovalFail,
  prioritizePropertySuccess,
  prioritizePropertyFail,
  searchPropertiesSuccess,
  searchPropertiesFail,
  getNotificationsSuccess,
  getNotificationsFail,
  getRegisteredPropertiesPercentagesByZoneSuccess,
  getRegisteredPropertiesPercentagesByZoneFail,
  getTiDetailsSuccess,
  getTiDetailsFail,
  getTiPropertStatsSuccess,
  getTiPropertStatsFail,
  getRegisteredPropertiesSuccess,
  getRegisteredPropertiesFail,
  getLookupTableDataSuccess,
  getLookupTableDataFail,
  updatePropertyDetailSuccess,
  updatePropertyDetailFail,
  getUploadLookupDataSuccess,
  getUploadLookupDataFail,
  fetchLookupReportSuccess,
  fetchLookupReportFail,
  fetchRegisteredPropertySuccess,
  fetchRegisteredPropertyFail,
  fetchUnRegisteredPropertySuccess,
  fetchUnRegisteredPropertyFail,
  getFilterMetaDataSuccess,
  getFilterMetaDataFail,
  getLatestDataFileSuccess,
  getLatestDataFileFail,
  getDcRateHistorySuccess,
  getDcRateHistoryFail,
} from "../actionCreators/Property";
import { doGet, doPost, doPostFormData, doPut } from "../utils/request";

function* fetchLookupReport({ obj }) {
  try {
    const response = yield doGet(
      `/datatable/download-error-report?fileId=${obj?.fileId}`
    );
    yield put(fetchLookupReportSuccess(response.data));
  } catch (err) {
    yield put(fetchLookupReportFail(err.response.data.message || err.message));
    yield put(fetchLookupReportFail());
  }
}

function* getUploadLookupData({ obj }) {
  try {
    const response = yield doGet(
      `/datatable/all?page=${obj.page}&pageSize=${obj.pageSize}&district_id=${obj?.district_id}`
    );
    yield put(getUploadLookupDataSuccess(response.data));
  } catch (err) {
    yield put(
      getUploadLookupDataFail(err.response.data.message || err.message)
    );
    yield put(getUploadLookupDataFail());
  }
}

function* fetchRegisteredProperty({ obj }) {
  try {
    // const response = yield doGet(
    //   `/properties/getRegisteredProperties?page=${obj?.page}&pageSize=${obj?.pageSize}&ownerName=${obj?.ownerName}&filterBody=${obj?.filterBody}`
    // );
    const response = yield doGet(
      `/properties/all?page=${obj?.page}&pageSize=${obj?.pageSize}&type=existing&filterBody=${obj?.filterBody}`
    );
    yield put(fetchRegisteredPropertySuccess(response.data));
  } catch (err) {
    yield put(fetchRegisteredPropertyFail(err.message));
  }
}

function* fetchUnRegisteredProperty({ obj }) {
  try {
    const response = yield doGet(
      `/properties/all?page=${obj?.page}&pageSize=${obj?.pageSize}&type=unregistered&filterBody=${obj?.filterBody}`
    );
    yield put(fetchUnRegisteredPropertySuccess(response.data));
  } catch (err) {
    yield put(fetchUnRegisteredPropertyFail(err.message));
  }
}
// ------------------------------------------------------------
function* getLookupTableData({ obj }) {
  try {
    const response = yield doGet(
      `/datatable/getData?page=${obj?.page}&pageSize=${obj?.pageSize}&districtId=${obj?.districtId}&filter=${obj.filterBody}`
    );
    yield put(getLookupTableDataSuccess(response.data));
  } catch (err) {
    yield put(getLookupTableDataFail(err.message));
  }
}

function* getCurrentProperty({ obj }) {
  try {
    const response = yield doGet(`/properties/current?property_id=${obj.id}`);
    yield put(getCurrentPropertySuccess(response.data));
  } catch (err) {
    yield put(getCurrentPropertyFail(err.message));
  }
}

function* getProperties({ obj }) {
  try {
    const response = yield doGet(
      `/properties/all?page=${obj.page}&pageSize=${obj.pageSize}&type=${obj.type}&filter=${obj.filter}&filterBody=${obj.filterBody}&search_by_name=${obj.search_by_name}`
    );
    yield put(getPropertiesSuccess(response.data));
  } catch (err) {
    yield put(getPropertiesFail(err.response.data.message || err.message));
    yield put(getPropertiesFail());
  }
}

function* getRegisteredProperties({ obj }) {
  try {
    let filterString = "";
    if (obj.filters && obj.filters.length > 0) {
      obj.filters.forEach((filter) => {
        filterString += `&filters[]=${filter}`;
      });
    }
    const response = yield doGet(
      `/properties/registered?page=${obj.page}&pageSize=${obj.pageSize}${filterString}`
    );
    yield put(getRegisteredPropertiesSuccess(response.data));
  } catch (err) {
    yield put(
      getRegisteredPropertiesFail(err.response.data.message || err.message)
    );
    yield put(getRegisteredPropertiesFail());
  }
}

function* getMlProperties({ obj }) {
  try {
    let url;
    if (obj) {
      url = `/properties/detected/all?page=${obj?.page}&pageSize=${obj?.pageSize}&highway_id=${obj.highway_id}`;
    } else {
      url = `/properties/detected/all`;
    }
    const response = yield doGet(url);
    yield put(getMlPropertiesSuccess(response.data));
  } catch (err) {
    yield put(getMlPropertiesFail(err.response.data.message || err.message));
    yield put(getMlPropertiesFail());
  }
}
function* getMlEngineProperties({ obj }) {
  try {
    let url;
    if (obj) {
      url = `/properties/detected/all?highway_id=${obj.highway_id}`;
    } else {
      url = `/properties/detected/all`;
    }
    const response = yield doGet(url);
    yield put(getMlEnginePropertiesSuccess(response.data));
  } catch (err) {
    yield put(
      getMlEnginePropertiesFail(err.response.data.message || err.message)
    );
    yield put(getMlEnginePropertiesFail());
  }
}

function* getCircles() {
  try {
    const response = yield doGet(`/dropdowns/circles`);

    yield put(getCirclesSuccess(response.data));
  } catch (err) {
    yield put(getCirclesFail(err.response.data.message || err.message));
    yield put(getCirclesFail());
  }
}

function* setPropertyApproval({ obj }) {
  try {
    const response = yield doPost(`/properties/approval`, obj);
    yield put(setPropertyApprovalSuccess(response.data));
  } catch (err) {
    yield put(
      setPropertyApprovalFail(err.response.data.message || err.message)
    );
    yield put(setPropertyApprovalFail());
  }
}

function* getNotificationCount() {
  try {
    const response = yield doGet(`/notification/count`);
    yield put(getNotificationCountSuccess(response.data));
  } catch (err) {
    yield put(
      getNotificationCountFail(err.response.data.message || err.message)
    );
    yield put(getNotificationCountFail());
  }
}

function* prioritizeProperty({ obj }) {
  try {
    const response = yield doPost(`/properties/prioritize`, obj);

    yield put(prioritizePropertySuccess(response.data));
  } catch (err) {
    yield put(prioritizePropertyFail(err.response.data.message || err.message));
    yield put(prioritizePropertyFail());
  }
}

function* searchProperties({ obj }) {
  try {
    const response = yield doPost(`/properties/search`, obj);

    yield put(searchPropertiesSuccess(response.data));
  } catch (err) {
    yield put(searchPropertiesFail(err.response.data.message || err.message));
    yield put(searchPropertiesFail());
  }
}
function* getNotifications({ obj }) {
  try {
    let url;
    if (obj) {
      url = `/notification/all?page=${obj?.page}&pageSize=${obj?.pageSize}`;
    } else {
      url = `/notification/all`;
    }
    const response = yield doGet(url);
    yield put(getNotificationsSuccess(response.data));
  } catch (err) {
    yield put(getNotificationsFail(err.response.data.message || err.message));
    yield put(getNotificationsFail());
  }
}

function* getRegisteredPropertiesPercentagesByZone({ obj }) {
  try {
    let url = obj?.districtId
      ? `/properties/totalRegisteredPropertiesPercentagesByZone?districtId=${obj?.districtId}`
      : "/properties/totalRegisteredPropertiesPercentagesByZone";
    const response = yield doGet(url);
    yield put(getRegisteredPropertiesPercentagesByZoneSuccess(response.data));
  } catch (err) {
    yield put(
      getRegisteredPropertiesPercentagesByZoneFail(
        err.response.data.message || err.message
      )
    );
    yield put(getRegisteredPropertiesPercentagesByZoneFail());
  }
}

function* getTiDetails({ obj }) {
  try {
    let url = `/taxinspector/${obj?.tiId}`;
    const response = yield doGet(url);
    yield put(getTiDetailsSuccess(response.data));
  } catch (err) {
    yield put(getTiDetailsFail(err.response.data.message || err.message));
    yield put(getTiDetailsFail());
  }
}

function* getTiPropertStats({ obj }) {
  try {
    let url = `/properties/getTIPropertyStats/${obj?.tiId}/circle/${obj?.circleId}`;
    const response = yield doGet(url);
    yield put(getTiPropertStatsSuccess(response.data));
  } catch (err) {
    yield put(getTiPropertStatsFail(err.response.data.message || err.message));
    yield put(getTiPropertStatsFail());
  }
}

function* updatePropertyDetail({ obj }) {
  try {
    const response = yield doPut("/datatable/updateData", obj); //{ data: { msg: "working", params: obj, success: true }, }// yield doPut(`testapi`,obj);
    yield put(updatePropertyDetailSuccess(response.data));
  } catch (err) {
    yield put(
      updatePropertyDetailFail(err.response.data.message || err.message)
    );
    yield put(updatePropertyDetailFail());
  }
}
function* getLatestDataFile({ obj }) {
  try {
    const response = yield doGet(`/datatable/latest?district_id=${obj?.district_id}`);
    yield put(getLatestDataFileSuccess(response.data));
  } catch (err) {
    yield put(getLatestDataFileFail(err.response.data.message || err.message));
    yield put(getLatestDataFileFail());
  }
}

function* getFilterMetaData() {
  try {
    const response = yield doGet("/zones/all");
    yield put(getFilterMetaDataSuccess(response?.data));
  } catch (err) {
    yield put(getFilterMetaDataFail(err.response.data.message || err.message));
  }
}

function* getDcRateHistory({ obj }) {
  try {
    const response = yield doGet(`/history/dcRate?id=${obj?.id}`);
    yield put(getDcRateHistorySuccess(response.data));
  } catch (err) {
    yield put(getDcRateHistoryFail(err.response.data.message || err.message));
    yield put(getDcRateHistoryFail());
  }
}

export default function* watcher() {
  yield all([
    takeLatest("GET_FILTER_META_DATA", getFilterMetaData),
    takeLatest("FETCH_LOOKUP_REPORT", fetchLookupReport),
    takeLatest("GET_UPLOAD_LOOKUP_DATA", getUploadLookupData),
    takeLatest("UPDATE_PROPERTY_DETAIL", updatePropertyDetail),
    takeLatest("GET_LOOKUP_TABLE_DATA", getLookupTableData),
    takeLatest("GET_PROPERTIES", getProperties),
    takeLatest("GET_REGISTERED_PROPERTIES", getRegisteredProperties),
    takeLatest("GET_ML_PROPERTIES", getMlProperties),
    takeLatest("GET_ML_ENGINE_PROPERTIES", getMlEngineProperties),
    takeLatest("GET_CURRENT_PROPERTY", getCurrentProperty),
    takeLatest("GET_CIRCLES", getCircles),
    takeLatest("GET_NOTIFICATION_COUNT", getNotificationCount),
    takeLatest("SET_PROPERTY_APPROVAL", setPropertyApproval),
    takeLatest("PRIORITIZE_PROPERTY", prioritizeProperty),
    takeLatest("SEARCH_PROPERTIES", searchProperties),
    takeLatest("GET_NOTIFICATIONS", getNotifications),
    takeLatest(
      "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE",
      getRegisteredPropertiesPercentagesByZone
    ),
    takeLatest("GET_TI_DETAILS", getTiDetails),
    takeLatest("GET_TI_PROPERTY_STATS", getTiPropertStats),
    takeLatest("FETCH_REGISTERED_PROPERTY", fetchRegisteredProperty),
    takeLatest("FETCH_UNREGISTERED_PROPERTY", fetchUnRegisteredProperty),
    takeLatest("GET_LATEST_DATA_FILE", getLatestDataFile),
    takeLatest("GET_DC_RATE_HISTORY", getDcRateHistory),
  ]);
}
